import {
  GET_ACCOUNT, GET_ACCOUNT_SUCCESS, GET_ACCOUNT_FAILURE, CLEAR_ACCOUNT_CACHE,
} from '../actions/account';

const INITIAL_STATE = { loading: true, requested: false };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_ACCOUNT:
      return {
        ...state,
        loading: true,
        error: false,
        requested: true,
      };
    case GET_ACCOUNT_SUCCESS: return (() => {
      const { services } = action.payload;
      const devices = {
        list: [],
        bySerial: {},
      };
      Object.keys(services || {}).forEach((lob) => {
        const { devices: d } = services[lob];
        if (!d) return;
        d.forEach((dev) => {
          const copy = {
            ...dev,
            lob,
          };
          devices.bySerial[copy.serialNumber] = copy;
          devices.list.push(copy);
        });
      }, {});
      return {
        ...state, loading: false, data: action.payload, devices, cached: true,
      };
    })();
    case GET_ACCOUNT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CLEAR_ACCOUNT_CACHE:
      return { ...state, cached: false };
    default:
      return state;
  }
}
